import { render, staticRenderFns } from "./MoveBrandRow.vue?vue&type=template&id=5f56e7f7&scoped=true"
import script from "./MoveBrandRow.vue?vue&type=script&lang=js"
export * from "./MoveBrandRow.vue?vue&type=script&lang=js"
import style0 from "./MoveBrandRow.vue?vue&type=style&index=0&id=5f56e7f7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56e7f7",
  null
  
)

export default component.exports